import { useTheme } from "../../contexts/ThemeContext";
import Modal from "./Modal";

// Dialog pequeno para confirmar ações destrutivas.
// Uso: <ConfirmDialog open title message danger loading onCancel onConfirm />
export default function ConfirmDialog({
  open,
  title = "Confirmar ação",
  message,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  danger = false,
  loading = false,
  onCancel,
  onConfirm,
}) {
  const { C, isDark } = useTheme();

  return (
    <Modal open={open} onClose={loading ? undefined : onCancel} title={title} width={420}>
      <p
        style={{
          margin: "0 0 4px",
          fontSize: 13,
          color: C.textMuted,
          lineHeight: 1.5,
        }}
      >
        {message}
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 10,
          marginTop: 22,
          paddingTop: 18,
          borderTop: `1px solid ${C.border}`,
        }}
      >
        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          style={{
            padding: "10px 18px",
            borderRadius: 10,
            border: `1px solid ${C.border}`,
            background: "transparent",
            color: C.textMuted,
            fontSize: 13,
            fontWeight: 600,
            cursor: loading ? "not-allowed" : "pointer",
            fontFamily: "'DM Sans', sans-serif",
          }}
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={loading}
          style={{
            padding: "10px 22px",
            borderRadius: 10,
            border: "none",
            background: danger
              ? `linear-gradient(135deg, ${C.red}, #EF4444)`
              : `linear-gradient(135deg, ${C.accent}, ${C.accentLight})`,
            color: danger ? "#fff" : isDark ? "#0B1219" : "#fff",
            fontSize: 13,
            fontWeight: 700,
            cursor: loading ? "wait" : "pointer",
            opacity: loading ? 0.7 : 1,
            fontFamily: "'DM Sans', sans-serif",
          }}
        >
          {loading ? "Processando..." : confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
